/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MaybeMigrateSavingsV2Request} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {MaybeMigrateSavingsV2Response} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const maybeMigrateSavingsV2 = (request: MaybeMigrateSavingsV2Request, options?: CashRequestOptions) => post<MaybeMigrateSavingsV2Request, MaybeMigrateSavingsV2Response>("/2.0/cash/maybe-migrate-savings-v2", request, {...options, rejectOnError: true })